
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class AuthFormLink extends Vue {
  @Prop({ type: String, default: "Click here" }) readonly text!: string;
  @Prop({ type: String, default: undefined }) readonly link?: string;
  @Prop({ type: Boolean, default: false }) readonly action!: boolean;
  @Prop({ type: Boolean, default: false }) readonly external!: boolean;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;
  @Prop({ type: Object, default: undefined }) readonly routerObject!: Record<string, any>;

  get routerTo(): string | object {
    if (!this.link && this.routerObject) {
      return this.routerObject;
    }
    return this.link || "";
  }

  get linkSize(): Record<string,boolean> {
    return {
      "text-base": !this.small,
      "text-sm": this.small,
    };
  }
};
